import React from 'react';
import styles from './HowItWorksSceneForeground.scss';
import 'swiper/dist/css/swiper.css';
import './HowItWorksSceneForeground.css';
import classNames from 'classnames/bind';
import {BubbleLabel} from '../../molecules';
import {
  TemperatureIcon,
  HumidityIcon,
  ChemicalIcon,
  CO2Icon,
  DustIcon
} from '../../atoms';
import {FaTimes} from 'react-icons/fa'

const cx = classNames.bind(styles);

const HowItWorksSceneForeground = ({
  swiperShow,
  swiperHide
}) => {
  const swiperStyle = {
    display: 'none'
  };
  const sensorIconColor = '#A4AAB1';

  return (
    <div className={cx('scene-foreground')} id="scene-foreground">
      <p className={cx('scene-statement')}><span lang='en-thin'>Awair</span>は空気の質を決定する5つの要素をセンサーでチェックします。</p>
      <BubbleLabel
        bubbleType='bubble-temp'
        bubbleSVG={<TemperatureIcon />}
        labelTitle='温度'
        labelDesc='湿度が適切でないと風邪をひきやすくなったり、アトピー症状を悪化させたりします。'
        dataTarget='temperature'
        swiperShow={swiperShow}
      />
      <BubbleLabel
        bubbleType='bubble-humidity'
        bubbleSVG={<HumidityIcon />}
        labelTitle='湿度'
        labelDesc='湿度が適切でないと風邪をひきやすくなったり、アトピー症状を悪化させたりします。'
        dataTarget='humidity'
        swiperShow={swiperShow}
      />
      <BubbleLabel
        bubbleType='bubble-chemicals'
        bubbleSVG={<ChemicalIcon />}
        labelTitle='化学物質(VOC)'
        labelDesc='家具やおもちゃなど、日常的に接するものからも皮膚や呼吸器に影響を及ぼしてしまう毒性の化学物質が発生していることがあります。'
        dataTarget='chemicals'
        swiperShow={swiperShow}
      />
      <BubbleLabel
        bubbleType='bubble-co2'
        bubbleSVG={<CO2Icon />}
        labelTitle='二酸化炭素'
        labelDesc='二酸化炭素濃度が高いと集中力と意思決定能力を低下させてしまいます。'
        dataTarget='co2'
        swiperShow={swiperShow}
      />
      <BubbleLabel
        bubbleType='bubble-dust'
        bubbleSVG={<DustIcon />}
        labelTitle='ホコリ'
        labelDesc='PM2.5を含む微細なホコリは肺に入りやすく、喘息やアレルギー症状へ影響を及ぼす可能性があります。'
        dataTarget='dust'
        swiperShow={swiperShow}
      />

      <div className='swiper-container factors-mask' id="factors-swiper" style={swiperStyle}>
        <div className='swiper-wrapper factors-set'>
          <div className='swiper-slide factors-slide'>
            <div className='factor-info'>
              <TemperatureIcon
                color={sensorIconColor}
              />
              <h3>温度</h3>
              <p>温度は快適さや気分を大きく左右する要素です。</p>
            </div>
          </div>
          <div className='swiper-slide factors-slide'>
            <div className='factor-info'>
              <HumidityIcon
                color={sensorIconColor}
              />
              <h3>湿度</h3>
              <p>湿度が適切でないと風邪をひきやすくなったり、アトピー症状を悪化させたりします。</p>
            </div>
          </div>
          <div className='swiper-slide factors-slide'>
            <div className='factor-info'>
              <CO2Icon
                color={sensorIconColor}
              />
              <h3>二酸化炭素</h3>
              <p>二酸化炭素濃度が高いと集中力と意思決定能力を低下させてしまいます。</p>
            </div>
          </div>
          <div className='swiper-slide factors-slide'>
            <div className='factor-info'>
              <ChemicalIcon
                color={sensorIconColor}
              />
              <h3>化学物質(<span lang='en-regular'>VOC</span>)</h3>
              <p>家具やおもちゃなど、日常的に接するものからも皮膚や呼吸器に影響を及ぼしてしまう毒性の化学物質が発生していることがあります。</p>
            </div>
          </div>
          <div className='swiper-slide factors-slide'>
            <div className='factor-info'>
              <DustIcon
                color={sensorIconColor}
              />
              <h3>ホコリ</h3>
              <p><span lang='en-thin'>PM</span>2.5を含む微細なホコリは肺に入りやすく、喘息やアレルギー症状へ影響を及ぼす可能性があります。</p>
            </div>
          </div>
        </div>
        <div className='swiper-pagination' />
        <div onClick={() => swiperHide()} className='close-factors-swiper'><FaTimes /></div>
      </div>
    </div>
  );
};

export default HowItWorksSceneForeground;




// WEBPACK FOOTER //
// ./src/app/components/organisms/HowItWorksSceneForeground/HowItWorksSceneForeground.js